import React, { useEffect, useState } from "react";
import ModalBody from "./ModalBody";
import { Card, Button, Divider, InlineStack, Icon, Text, BlockStack, Tooltip } from "@shopify/polaris";
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { PricingIcon } from "../svg/Images";
import { DI, DIProps } from "../../../../../Core";
import { appBridgeRedirect } from "../../../Panel/index";
import '../styles/styles.css';
import { formatDate } from "../../Utilities/Helper";
import { useTranslation } from "react-i18next";

interface props extends DIProps {
  settlementData: any
}

const SettlementModal = (props: props) => {
  const { t } = useTranslation();
  const { settlementData } = props;
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [loadPayButton, setloadPayButton] = useState<boolean>(false);
  const [activePlanName, setactivePlanName] = useState<any>();
  const [syncActivated, setSyncActivated] = useState<boolean>(true);
  useEffect(() => {
    props.location.pathname == "/panel/user/home/pricing" &&
      setIsModalOpen(true);
    setIsModalOpen(true);
    getActive()
  }, [])

  const getActive = () => {
    props.di.GET('plan/plan/getActive').then((data: any) => {
      if (data.success) {
        setactivePlanName(data?.data?.active_plan?.plan_details?.title);
        setSyncActivated(data?.data?.sync_activated)
      }
      else setactivePlanName('')
    });
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const formatDate = (date: string) => {
    var monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let d = new Date(date);
    let dd = d.getDate() + '';
    if (dd === '1') dd += 'st';
    else if (dd === '2') dd += 'nd';
    else if (dd === '3') dd += 'rd';
    else dd += 'th'

    let mm = monthList[d.getMonth()] + ','

    let yy = d.getFullYear()

    return (dd + ' ' + mm + ' ' + yy)
  }

  const settleServices = (amt: string | number) => {

    setloadPayButton(true);
    props.di.GET('plan/plan/settleServices', {
      amount: amt,
      type: 'onetime',
    })
      .then((data: any) => {
        if (data.success) {
          let tempUrl = data?.data?.confirmation_url ?? '';

          if (data.message == 'Capped amount already set.') {
            props.error(t(data?.message));
            setloadPayButton(false);
          } else if (process.env.REACT_APP_PROD === "1") {
            props.di.globalState.removeLocalStorage('isSettlementGenerated')
            props.history('home')
            appBridgeRedirect(tempUrl, props);
          } else {
            window.open(tempUrl);
          }
        } else {
          props.error(t(data?.message));
        }
        setloadPayButton(false);
      });
  }

  return <>
    <div className="custom-modal--PricingOpen">
      <Button size="large" onClick={handleOpenModal} icon={<PricingIcon />} />
    </div>
    <ModalBody isOpen={isModalOpen} onClose={handleCloseModal}>
      <Card>
        <BlockStack gap="400">
          <BlockStack gap="300">
            <Text variant="headingLg" as="p" fontWeight="regular">{t("Generated Excess Usage Charges")}</Text>
            <Text variant="heading3xl" as="p">{`$${settlementData?.settlement_price?.toFixed(2) ?? 0.00} USD`}</Text>
          </BlockStack>
          <Divider />
          <BlockStack gap="300">
            <InlineStack align="space-between" gap="300">
              <Text as='p'>Orders</Text>
              <Text as='p'>{`${settlementData?.settlement_order ?? 0} ${settlementData?.settlement_order > 1 ? 'orders ' : 'order '}`}
                ({
                  '$' + settlementData?.invoice?.postpaid?.per_unit_usage_price || 0.00}/ {settlementData?.invoice?.postpaid?.unit_qty > 1 ? settlementData?.invoice?.postpaid?.unit_qty + ' orders' : settlementData?.invoice?.postpaid?.unit_qty + ' order'
                })
              </Text>
            </InlineStack>
            <InlineStack align="space-between" gap="300">
              <Text as='p'>Bill generated on</Text>
              <Text as='p'>{formatDate(settlementData?.invoice?.generated_at)}</Text>
            </InlineStack>
            <InlineStack align="space-between" gap="300">
              <Text as='p'>Payment Last Date</Text>
              <Text as='p'>{formatDate(settlementData?.invoice?.last_payment_date)}</Text>
            </InlineStack>
          </BlockStack>
          <Divider />
          <BlockStack gap="300">
            <div>
              {
                !settlementData?.show_pay_now ?
                  <Tooltip zIndexOverride={99999999999} content={t("You can settle charges from two days before your final payment date or when your excess credit usage reaches 90%.")}>
                    <Button
                      disabled={!settlementData?.show_pay_now}
                      loading={loadPayButton}
                      onClick={() => settleServices(settlementData?.settlement_price)}
                    >Pay Now
                    </Button>
                  </Tooltip> :
                  <Button
                    disabled={!settlementData?.show_pay_now}
                    loading={loadPayButton}
                    onClick={() => settleServices(settlementData?.settlement_price)}
                  >Pay Now
                  </Button>

              }

            </div>
            <div>
              <Button


                onClick={() => activePlanName == '' || !syncActivated ? props.history('../panel/support', {
                  replace: false,
                  state: {
                    fromPricingPlan: true
                  }
                }) : props.history('support')}
                variant="monochromePlain">Contact us</Button>{' '}<span className="disabled-text"> or read the</span> <Button


                  onClick={() => {
                    if (activePlanName == '' || !syncActivated) {
                      props.di.globalState.set('fromPricingPlan', 'true')
                      props.history('../panel/faq')
                    } else {
                      props.di.globalState.set('fromPricingPlan', 'true')
                      props.history('faq')
                    }
                  }}
                  variant="monochromePlain">frequently asked questions</Button>{' '} <span className="disabled-text">for further assistance.</span>
            </div>
          </BlockStack>
        </BlockStack>
      </Card>
      <div className="custom-modal--PricingClose">
        <Button size="large" onClick={handleCloseModal} icon={<Icon
          source={MobileCancelMajor}
          tone="primary"
        />} />
      </div>
    </ModalBody>
  </>;
};

export default DI(SettlementModal);